/* eslint-disable import/prefer-default-export */
export const ENTITY_SCOPE_TYPES = {
  PUBLIC: 'public',
  PRIVATE: 'private',
};
